(function () {
  'use strict';

  function clearBrokenRecentStorage() {
    try {
      window.localStorage.removeItem('theme-recent');
    } catch (error) {
      /* 保存領域を使えない環境では何もしない */
    }
  }

  function readRecentStorage() {
    var stored;
    try {
      stored = window.localStorage.getItem('theme-recent');
    } catch (error) {
      return null;
    }
    if (!stored) return null;

    try {
      var recent = JSON.parse(stored);
      if (!recent || typeof recent !== 'object' || Array.isArray(recent)) {
        clearBrokenRecentStorage();
        return null;
      }
      return recent;
    } catch (error) {
      clearBrokenRecentStorage();
      return null;
    }
  }

  /* deferのtheme.jsが同じ値を読む前に、壊れた履歴だけを安全に取り除く */
  readRecentStorage();

  /* テーマエディタで同じ資産が再評価されたときは、監視を重ねず新しい節だけ初期化する */
  if (window.NKProductShelves && typeof window.NKProductShelves.init === 'function') {
    window.NKProductShelves.init(document);
    return;
  }

  /* いまの言語の接頭辞を返す（英語は空・ドイツ語なら "/de"）。#156
     theme.routes.home は英語だと "/" なので、そのまま繋ぐと "//products/…" になり
     ブラウザが「products という別のサイト」として読みにいく。必ずここを通す */
  function localeRoot() {
    var home = (window.theme && window.theme.routes && window.theme.routes.home) || '/';
    home = String(home);
    if (home === '/' || home === '') return '';
    return home.replace(/\/+$/, '');
  }

  function forEachItem(items, callback) {
    Array.prototype.forEach.call(items, callback);
  }

  function bindShelfBar(shelf) {
    if (!shelf || shelf.dataset.nkProductBarBound === '1') return;

    var track = shelf.querySelector('[data-nk-product-shelf-row]');
    var thumb = shelf.querySelector('.nk-product__sthumb');
    if (!track || !thumb) return;

    shelf.dataset.nkProductBarBound = '1';

    function update() {
      if (track.isConnected === false) return;

      var ratio = track.clientWidth / track.scrollWidth;
      if (!isFinite(ratio) || ratio >= 1) {
        thumb.parentNode.style.display = 'none';
        return;
      }

      thumb.parentNode.style.display = '';
      var widthPercent = Math.max(ratio * 100, 8);
      var maxScroll = track.scrollWidth - track.clientWidth;
      var position = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      thumb.style.width = widthPercent + '%';
      thumb.style.left = (position * (100 - widthPercent)) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    /* 縦回転はページへ渡し、横回転と横スワイプだけを棚で受け取る */
    track.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        event.preventDefault();
        window.scrollBy(0, event.deltaY);
      }
    }, { passive: false });

    update();
  }

  function showShelf(shelf) {
    var row = shelf && shelf.querySelector('[data-nk-product-shelf-row]');
    if (!row || row.children.length === 0) return;

    if (window.nkCurrencyRef) window.nkCurrencyRef.refresh(row);
    shelf.hidden = false;
    bindShelfBar(shelf);
    document.dispatchEvent(new CustomEvent('nk:cards-added'));
  }

  function revealArtistLinks(root) {
    forEachItem(root.querySelectorAll('[data-nk-artist-link]'), function (link) {
      link.hidden = false;
    });
    /* 2026-09-22 オーナー決定（#261）: リンクを出すときだけ、絵師の箱も出す。
       他に品が無い絵師では箱ごと出ない（白い枠に名前だけ、を防ぐ）。
       ⚠️ 絵師名は題名のすぐ下（.nk-product__by）にも出ているので情報は失われない。 */
    forEachItem(root.querySelectorAll('[data-nk-artist-box]'), function (box) {
      box.hidden = false;
    });
    forEachItem(root.querySelectorAll('[data-nk-artist-plain]'), function (name) {
      name.hidden = true;
    });
  }

  function loadServerShelf(root, shelf) {
    var row = shelf.querySelector('[data-nk-product-shelf-row]');
    var url = shelf.dataset.shelfUrl;
    var currentProductId = root.dataset.productId;
    if (!row || !url) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Shelf request failed');
        return response.text();
      })
      .then(function (html) {
        if (shelf.isConnected === false) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var cards = parsed.querySelectorAll('[data-nk-product-card][data-product-id]');
        var seenProductIds = {};
        var shown = 0;

        forEachItem(cards, function (card) {
          var productId = card.getAttribute('data-product-id');
          if (shown >= 10 || !productId || productId === currentProductId || seenProductIds[productId]) return;

          seenProductIds[productId] = true;
          row.appendChild(card.cloneNode(true));
          shown += 1;
        });

        showShelf(shelf);
        if (shelf.dataset.shelfKind === 'artist' && !shelf.hidden) revealArtistLinks(root);
      })
      .catch(function () {
        /* 取得できない棚は見出しごとhiddenのままにする */
      });
  }

  function productImageUrl(product, recentEntry) {
    var source = product.featured_image || (recentEntry && recentEntry.featuredImage) || '';
    if (!source) return '';

    if (source.indexOf('{width}') !== -1) {
      return source.replace('{width}', '640');
    }

    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', '640');
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function setProductPrice(element, product, shelves) {
    setDollarPrice(element, product, shelves);
    var cents = Number(product.price);
    if (!Number.isSafeInteger(cents) || cents < 0) return;
    var reference = document.createElement('span');
    reference.className = 'nk-cref__card';
    reference.setAttribute('data-nk-cur-ref', '');
    reference.setAttribute('data-nk-cents', String(cents));
    element.appendChild(document.createTextNode(' '));
    element.appendChild(reference);
  }

  // USDの表示書式と既存の代替表示を変えず、参考価格とは分けて描く。
  function setDollarPrice(element, product, shelves) {
    var price = Number(product.price);
    if (!isFinite(price)) return;

    if (window.theme && window.theme.settings && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      element.innerHTML = window.theme.Currency.formatMoney(price, window.theme.settings.moneyFormat);
      return;
    }

    var currencyCode = shelves.dataset.currencyCode;
    if (currencyCode && window.Intl && Intl.NumberFormat) {
      try {
        element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currencyCode
        }).format(price / 100);
        return;
      } catch (error) {
        /* 未知の通貨コードなら、下の記号＋小数表記へ戻す */
      }
    }

    element.textContent = (shelves.dataset.currencySymbol || '') + (price / 100).toFixed(2);
  }

  /* #218: 取り置きの問い合わせを待つ上限。これを過ぎたら打ち切って今までどおりの札で描く。 */
  var RESERVED_LOOKUP_TIMEOUT_MS = 5000;

  /* #218: 取り置き中のハンドルをまとめて1回だけ聞く。
     商品JSON（/products/<handle>.js）には目印が載らないので、ここだけ別に読む。
     取れなかったときは空の一覧を返し、今までどおりの札で描く（黙って消えない）。 */
  function fetchReservedHandles(handles) {
    var wanted = (handles || []).filter(function (handle) {
      return typeof handle === 'string' && handle !== '';
    });
    if (wanted.length === 0) return Promise.resolve({});

    var query = encodeURIComponent(wanted.slice(0, 20).join(' '));
    /* ⚠️ 言語なしで読むと英語の棚を見にいく（#156 と同じ理由） */
    var url = localeRoot() + '/search?view=nk-reserved&q=' + query;

    /* 🛑 必ず打ち切る。応答が返ってこないと棚そのものが永久に出ない
       （カードを描くのも棚を見せるのも、この約束が解決したあとだから）。
       作法は assets/nk-account.js の cartRequest と同じ。 */
    var options = { credentials: 'same-origin' };
    var timer = null;
    if (typeof window.AbortController === 'function') {
      var controller = new window.AbortController();
      options.signal = controller.signal;
      timer = window.setTimeout(function () {
        controller.abort();
      }, RESERVED_LOOKUP_TIMEOUT_MS);
    }
    var done = function () {
      if (timer !== null) window.clearTimeout(timer);
    };

    return fetch(url, options)
      .then(function (response) {
        if (!response.ok) throw new Error('Reserved lookup failed');
        return response.json();
      })
      .then(function (payload) {
        done();
        var found = {};
        var list = payload && Array.isArray(payload.reserved) ? payload.reserved : [];
        for (var i = 0; i < list.length; i++) {
          if (typeof list[i] === 'string' && list[i] !== '') found[list[i]] = true;
        }
        return found;
      })
      .catch(function (error) {
        done();
        /* 取れなかったときは今までどおりの札で描く（棚は消さない）。
           ただし「RESERVED が出ない」と言われたときに原因を追えるよう痕跡を残す。 */
        if (window.console && window.console.warn) {
          window.console.warn('[nk] 取り置きの問い合わせに失敗しました。札は状態のまま描きます', error);
        }
        return {};
      });
  }

  function buildRecentCard(product, recentEntry, shelves, isReserved) {
    var state = window.NKState.fromProductJson(product);
    /* #270: 作品名は商品名まるごと（末尾の商品コードまで）。Liquid 側の
       snippets/nk-product-card.liquid と同じ出し方にそろえる。 */
    var title = String(product.title || '').trim();
    var card = document.createElement('a');
    card.className = 'nk-product__card';
    card.setAttribute('data-nk-product-card', '');
    card.setAttribute('data-product-id', String(product.id));
    card.setAttribute('data-product-handle', product.handle || '');
    card.setAttribute('data-nk-state', state);
    /* #218: 取り置きは状態より前に出す（ほかの描き方と同じ順。snippets/product-grid-item.liquid） */
    if (isReserved) card.setAttribute('data-nk-reserved', '1');
    if (state === 'coming') {
      var saleStart = window.NKState.saleStartFromTags(product.tags);
      if (saleStart) card.setAttribute('data-nk-sale-starts', saleStart);
      card.setAttribute('data-nk-shortly-label', shelves.dataset.comingShortlyLabel || '');
    }
    card.href = product.url || (localeRoot() + '/products/' + encodeURIComponent(product.handle));

    var figure = document.createElement('span');
    var figureState = isReserved ? 'reserved' : state;
    figure.className = 'nk-product__fig nk-product__cimg'
      + (figureState === 'available' ? '' : ' is-' + figureState);

    var imageSource = productImageUrl(product, recentEntry);
    if (imageSource) {
      var image = document.createElement('img');
      image.src = imageSource;
      image.alt = title;
      image.loading = 'lazy';
      image.width = 640;
      image.height = 480;
      figure.appendChild(image);
    }

    if (isReserved) {
      /* #218: 取り置き中は、売切れや抽選ではなく取り置きの札を出す（決定36） */
      var reserved = document.createElement('span');
      reserved.className = 'nk-product__cardsold';
      reserved.textContent = shelves.dataset.reservedLabel || '';
      figure.appendChild(reserved);
    } else if (state !== 'available') {
      var sold = document.createElement('span');
      sold.className = 'nk-product__cardsold';
      sold.textContent = shelves.dataset[state + 'Label'] || '';
      if (state === 'coming') sold.setAttribute('data-nk-state-text', '');
      figure.appendChild(sold);
    }

    var titleElement = document.createElement('span');
    titleElement.className = 'nk-product__ct';
    titleElement.textContent = title;

    var priceElement = document.createElement('span');
    priceElement.className = 'nk-product__cp';
    setProductPrice(priceElement, product, shelves);

    card.appendChild(figure);
    card.appendChild(titleElement);
    card.appendChild(priceElement);
    return card;
  }

  function loadRecentlyViewed(root, shelves, shelf) {
    var row = shelf.querySelector('[data-nk-product-shelf-row]');
    if (!row) return;

    var recent = readRecentStorage();
    if (!recent) return;

    var currentHandle = root.dataset.productHandle;
    var handles = Object.keys(recent).reverse().filter(function (handle) {
      return handle && handle !== 'undefined' && handle !== currentHandle;
    });
    if (handles.length === 0) return;

    var seenProductIds = {};
    var shown = 0;

    /* 履歴が多くても一度に全件取得せず、10件ずつ必要な分だけ読む */
    function loadBatch(startIndex) {
      var batchHandles = handles.slice(startIndex, startIndex + 10);
      var requests = batchHandles.map(function (handle) {
        /* ⚠️ 言語なしで読むと英語の題名と英語のURLが返る（2026-09-08 実測）。#156 */
        return fetch(localeRoot() + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Recent product request failed');
            return response.json();
          })
          .then(function (product) {
            return { product: product, entry: recent[handle] };
          })
          .catch(function () {
            return null;
          });
      });

      /* #218: 商品JSONと一緒に、取り置き中のハンドルもまとめて1回だけ聞く。
         カードを描いたあとで札を差し替えると SOLD → RESERVED と一瞬ちらつくので、
         両方そろってから描く。 */
      var batch = Promise.all([Promise.all(requests), fetchReservedHandles(batchHandles)]);

      batch.then(function (loaded) {
        if (shelf.isConnected === false) return;

        var results = loaded[0];
        var reservedHandles = loaded[1];

        results.forEach(function (result) {
          if (!result || shown >= 10) return;

          var product = result.product;
          if (!product || typeof product !== 'object') return;
          var productId = String(product.id || '');
          if (!productId || productId === root.dataset.productId || product.handle === currentHandle) return;
          var t = product.tags;
          var tags = Array.isArray(t) ? t : String(t || '').split(/,\s*/).filter(Boolean);
          if (tags.indexOf('site-all-hide') !== -1 || tags.indexOf('nk-coming-soon') !== -1 || tags.indexOf('nk-raffle') !== -1 || tags.indexOf('nk-hold-hide') !== -1) return;
          if (seenProductIds[productId]) return;

          seenProductIds[productId] = true;
          row.appendChild(buildRecentCard(
            product,
            result.entry,
            shelves,
            reservedHandles[product.handle] === true
          ));
          shown += 1;
        });

        var nextIndex = startIndex + batchHandles.length;
        if (shown < 10 && nextIndex < handles.length) {
          loadBatch(nextIndex);
          return;
        }

        showShelf(shelf);
      }).catch(function (error) {
        /* 描く途中で落ちても棚を隠したまま終わらせない（無言で消えるのを防ぐ） */
        if (window.console && window.console.warn) {
          window.console.warn('[nk] 最近見た作品の棚を描けませんでした', error);
        }
        if (shown > 0) showShelf(shelf);
      });
    }

    loadBatch(0);
  }

  function initRoot(root) {
    if (!root || root.dataset.nkProductShelvesBound === '1') return;

    var shelves = root.querySelector('[data-nk-product-shelves]');
    if (!shelves) return;
    root.dataset.nkProductShelvesBound = '1';

    forEachItem(shelves.querySelectorAll('[data-nk-product-shelf][data-shelf-url]'), function (shelf) {
      loadServerShelf(root, shelf);
    });

    var recentShelf = shelves.querySelector('[data-nk-product-shelf][data-shelf-kind="recent"]');
    if (recentShelf) loadRecentlyViewed(root, shelves, recentShelf);
  }

  function init(scope) {
    if (!scope || !scope.querySelectorAll) return;

    if (scope.matches && scope.matches('.nk-product')) initRoot(scope);
    forEachItem(scope.querySelectorAll('.nk-product'), initRoot);
  }

  window.NKProductShelves = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
